import DeclarationsFormSection from "../../../../common/form/applicant/DeclarationsFormSection";
import { useFormContext, useWatch } from "react-hook-form";
import { useEffect } from "react";

const SEDeclarationsFormSection = () => {
  const applicantHasRepresentative = useWatch({ name: "applicantHasRepresentative" });
  const { setValue } = useFormContext();

  useEffect(() => {
    setValue("documentsDeclaration", false);
  }, [applicantHasRepresentative]);

  return (
    <DeclarationsFormSection
      showAgreeMailCorrespondenceOption={true}
      showAgreeDeclarationLink={false}
      agreeDataUsageLabelCode={"l.declaration.agreeDataUsage.se.input"}
      documentDeclarationLabelCode={
        applicantHasRepresentative
          ? "l.declaration.documentsDeclaration.representative"
          : "l.declaration.documentsDeclaration.se"
      }
    />
  );
};
export default SEDeclarationsFormSection;
